export const PROFILE_V9_MAX_WIDTH = '1440px';
